import { createFileRoute } from '@tanstack/react-router'
import { PricingPage } from '../components/pricing-page'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/tarifs')({
  head: () => staticRouteHead('pricing', 'fr'),
  component: PricingPage,
})
